$(document).ready(function () {
    const mainHeader = $('.main-header')
    const headerMenuButton = mainHeader.find('.btn-show-menu')
    const headerSearchButton = mainHeader.find('.main-header__search-btn')
    const searchBar = mainHeader.find('.search-bar')

    headerMenuButton.on('click', function(){
        // toggle class
        mainHeader.toggleClass('menu-open')

        // toggle aria-expanded attribute
        headerMenuButton.attr('aria-expanded',$(this).attr('aria-expanded')==='true'?'false':'true' );

        // toggle button text
        var text = headerMenuButton.text()
        headerMenuButton.text(
            text == "Meny" ? "Lukk" : "Meny"
        )

        // Close search bar when closing menu
        if(headerMenuButton.attr('aria-expanded') == 'false'){
            hideSearchBar()
        }
    })

    // TOGGLE header search
    headerSearchButton.on('click', function (e) {
        if (headerSearchButton.attr('aria-expanded') == 'true') {
            // HIDE search bar
            hideSearchBar()
        } else {
            // SHOW search bar
            showSearchBar()
        }
    })

    // close search bar clicking outside the main-header
    window.addEventListener('click', function(e){
        if (!document.querySelector('.main-header').contains(e.target)){
            hideSearchBar()
        }
    })

    // close search bar by pressing esc
    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            //if esc key was not pressed in combination with ctrl or alt or shift
            const isNotCombinedKey = !(event.ctrlKey || event.altKey || event.shiftKey)
            if (isNotCombinedKey) {
                hideSearchBar()
            }
        }
    })

    function showSearchBar() {
        mainHeader.addClass('main-header--white main-header--search')
        searchBar.attr('aria-hidden', 'false')
        searchBar.find('input').focus()
        $('.main-header__search-btn').attr('aria-expanded', 'true')
        $('.main-header__search-btn').removeClass('btn--primary')
        $('.main-header__search-btn').addClass('btn--secondary')
    }
    
    function hideSearchBar() {
        mainHeader.removeClass('main-header--white main-header--search')
        searchBar.attr('aria-hidden', 'true')
        $('.main-header__search-btn').attr('aria-expanded', 'false')
        $('.main-header__search-btn').removeClass('btn--secondary')
        $('.main-header__search-btn').addClass('btn--primary')
    }
});
